import React from 'react';
import { Field } from 'redux-form';
import { PropTypes } from 'prop-types';
import { required } from 'redux-form-validators';

import { STATIC_ROOT } from '../../constants';

import SvgComponent from '../SvgComponent';
import { FormInputContainerComponent, ItemComponent } from './InputWrappersComponent';

const renderTextarea = ({ input, meta, label, classNameInputContainer, isRequired, formName }) => {
    return (
        <FormInputContainerComponent
            className={classNameInputContainer ? classNameInputContainer : ''}>
            <label htmlFor={`${input.name}-${meta.form}`} className="label">
                {label}
            </label>
            <ItemComponent className="item item-textarea">
                <textarea
                    {...input}
                    id={`${input.name}-${meta.form}`}
                    className={`input ${meta.touched && meta.error ? ' input-error' : ''}`}
                    aria-required={isRequired}
                    aria-invalid={meta.touched && meta.error ? 'true' : undefined}
                    aria-describedby={meta.touched && meta.error ? `error-${input.name}-${meta.form}` : undefined}
                />
            </ItemComponent>
            {meta.touched && meta.error && (
                <p className="input-error color-err" id={`error-${input.name}-${meta.form}`}>
                    <SvgComponent
                        src={`${STATIC_ROOT}/picto-errors.svg`}
                        width={20}
                        height={20}
                        aria-hidden="true"
                        focusable="false"
                    />
                    {meta.error}
                </p>
            )}
        </FormInputContainerComponent>
    );
};

class TextareaFieldComponent extends React.Component {
    validateDefault = () => {
        const { i18nFeatureForm, isRequired, requiredMessage } = this.props;
        if (isRequired) {
            return [
                required({
                    msg: requiredMessage ? requiredMessage : i18nFeatureForm.REQUIRED,
                    allowBlank: !isRequired
                })
            ];
        }
        return [];
    };

    render() {
        const { validate = [], label, isRequired } = this.props;
        return (
            <Field
                {...this.props}
                label={`${label ? label : ''}${label && isRequired ? '*' : ''}`}
                component={renderTextarea}
                validate={[...this.validateDefault(), ...validate]}
            />
        );
    }
}

TextareaFieldComponent.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    isRequired: PropTypes.bool,
    i18nFeatureForm: PropTypes.object,
    requiredMessage: PropTypes.string
};

export default TextareaFieldComponent;



// WEBPACK FOOTER //
// ./src/components/form/TextareaFieldComponent.js